import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { Alert } from '@dev/ee-components';
import { MarketingOptions } from '@dev/ee-api/ee-api-models';
import { remove } from 'lodash-es';
import { Link } from '@material-ui/core';

import { HomePaths } from '@/services/dictionaries/Paths';
import { AccountEditMarketingOptionsStart, getAccountStore } from '@/store/account/actions';

export const DPAUpdatedBanner = (): JSX.Element => {
    const dispatch = useDispatch();
    const { GeneralInfo } = useSelector(getAccountStore);
    const showDPABanner = GeneralInfo?.MarketingOptions.includes(MarketingOptions.DPADownloaded);
    
    if (!showDPABanner) {
        return null;
    }

    return (
        <Alert
            severity="info"
            isInfo
            body={
                <Trans
                    i18nKey="dpaupdated"
                    components={{
                        l: (<Link href={HomePaths.Security}/>),
                    }}
                />
            }
            onClose={(): void => {
                const marketingOptions = [...GeneralInfo.MarketingOptions];
                remove(marketingOptions, (option) => option === MarketingOptions.DPADownloaded);
                dispatch(AccountEditMarketingOptionsStart(marketingOptions));
            }}
        />
    );
};